// import React, { useState, useRef, useEffect } from "react";
// import { MultiValue } from "react-select";
// import { FaTimes } from "react-icons/fa";
// import { IoSearchOutline } from "react-icons/io5";
// import { FaPlus } from "react-icons/fa6";
// import { FaMinus } from "react-icons/fa6";

// interface OptionType {
//     value: string;
//     label: string;
// }

// interface TagSelectorProps {
//     options: OptionType[];
//     value: MultiValue<OptionType>;
//     onChange: (newValue: MultiValue<OptionType>) => void;
//     placeholder?: string;
// }

// const TagSelector: React.FC<TagSelectorProps> = ({
//     options,
//     value = [],
//     onChange,
//     placeholder = "Select tag(s)"
// }) => {
//     const [open, setOpen] = useState(false);
//     const [search, setSearch] = useState("");
//     const dropdownRef = useRef<HTMLDivElement>(null);

//     const Search = IoSearchOutline as any;
//     const Times = FaTimes as any;
//     const Plus = FaPlus as any;
//     const Minus = FaMinus as any;

//     // Close dropdown when clicking outside
//     useEffect(() => {
//         const handleClickOutside = (event: MouseEvent) => {
//             if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
//                 setOpen(false);
//             }
//         };

//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);

//     const toggleTag = (option: OptionType) => {
//         const exists = value.some(v => v.value === option.value);
//         if (exists) {
//             // Remove the tag
//             onChange([...value.filter(v => v.value !== option.value)] as MultiValue<OptionType>);
//         } else {
//             // Add the tag
//             onChange([...value, option] as MultiValue<OptionType>);
//         }
//     };

//     const removeTag = (option: OptionType) => {
//         onChange([...value.filter(v => v.value !== option.value)] as MultiValue<OptionType>);
//     };

//     const filteredOptions = options.filter((option) =>
//         option.label.toLowerCase().includes(search.toLowerCase())
//     );

//     return (
//         <div className="relative" ref={dropdownRef}>
//             <div
//                 onClick={() => setOpen(!open)}
//                 className="flex flex-wrap items-center w-full rounded-lg bg-[#F8F8F8] pl-[14px] pr-2.5 py-[11px] text-left min-h-[42px] cursor-pointer"
//             >
//                 {value.length > 0 ? (
//                     <div className="flex flex-wrap gap-1 w-full">
//                         {[...value].map((selected) => (
//                             <span
//                                 key={selected.value}
//                                 className="inline-flex items-center gap-1 bg-white text-gray-500 border capitalize text-xs px-2 py-1 rounded mr-1 mb-1"
//                             >
//                                 {selected.label}
//                                 <button
//                                     type="button"
//                                     className="text-gray-500 hover:text-gray-400"
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         removeTag(selected);
//                                     }}
//                                     aria-label={`Remove ${selected.label}`}
//                                 >
//                                     <Times size={12} />
//                                 </button>
//                             </span>
//                         ))}
//                         <p className={`m-0 text-xs text-gray-400 ${value.length > 0 ? 'self-center' : ''}`}>
//                             {value.length === 0 ? placeholder : ''}
//                         </p>
//                     </div>
//                 ) : (
//                     <p className="m-0 text-xs text-gray-400">{placeholder}</p>
//                 )}
//                 <div className="ml-auto absolute right-3">
//                     <svg
//                         height="20"
//                         width="20"
//                         viewBox="0 0 20 20"
//                         aria-hidden="true"
//                         focusable="false"
//                         className={`transition-transform duration-200 pointer-events-none ${open ? "rotate-180" : ""}`}
//                     >
//                         <path
//                             d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
//                             fill="#9a9da1"
//                         />
//                     </svg>
//                 </div>
//             </div>

//             {open && (
//                 <div className="absolute mt-1 w-full rounded-lg border border-gray-200 bg-white">
//                     <div className="">
//                         {/* Search */}
//                         <div className="flex mb-2 w-full border-b border-gray-300 px-3 text-xs">
//                             <Search className="text-sm text-gray-500" />
//                             <input
//                                 type="text"
//                                 placeholder="Search tags..."
//                                 value={search}
//                                 onChange={(e) => setSearch(e.target.value)}
//                                 className="text-xs"
//                                 style={{
//                                     border: "none",
//                                     background: "transparent",
//                                     outline: "none",
//                                     boxShadow: "none",
//                                 }}
//                             />
//                         </div>

//                         <div className="flex justify-between mb-2 px-3">
//                             <p className="m-0 text-xs text-gray-500 ">Tag</p>
//                             <div className=" flex justify-end gap-4 text-xs text-gray-500">
//                                 <span className="flex items-center gap-1">
//                                     <Plus className="rounded-full text-green-500 !text-[11px]" />
//                                     Include
//                                 </span>
//                                 <span className="flex items-center gap-1">
//                                     <Minus className="rounded-full text-red-500 !text-[11px]" />
//                                     Exclude
//                                 </span>
//                             </div>
//                         </div>

//                         {/* Tags */}
//                         {/* <div className="max-h-48 overflow-auto mt-1">
//                             {filteredOptions.length > 0 ? (
//                                 filteredOptions.map((option) => {
//                                     const isSelected = value.some(v => v.value === option.value);
//                                     return (
//                                         <div
//                                             key={option.value}
//                                             className={`flex items-center justify-between px-3 py-2 cursor-pointer ${isSelected ? 'bg-blue-50' : 'hover:bg-gray-50'}`}
//                                             onClick={() => toggleTag(option)}
//                                         >
//                                             <span className="text-sm">{option.label}</span>
//                                             {isSelected && (
//                                                 <span className="text-blue-600">
//                                                     ✓
//                                                 </span>
//                                             )}
//                                         </div>
//                                     );
//                                 })
//                             ) : (
//                                 <div className="px-3 py-2 text-sm text-gray-500">
//                                     No tags found
//                                 </div>
//                             )}
//                         </div> */}

//                         {/* Tags */}
//                         <div className="max-h-52 overflow-auto mt-1 no-scrollbar">
//                             {filteredOptions.length > 0 ? (
//                                 filteredOptions.map((option) => {
//                                     const isSelected = value.some(v => v.value === option.value);

//                                     return (
//                                         <div
//                                             key={option.value}
//                                             className={`flex items-center justify-between px-3 py-2
//                         ${isSelected ? "bg-blue-50" : "hover:bg-gray-50"}`}
//                                         >
//                                             <span className="text-sm capitalize">{option.label}</span>

//                                             <div className="flex gap-2">
//                                                 {/* PLUS = SELECT */}
//                                                 <button
//                                                     type="button"
//                                                     onClick={(e) => {
//                                                         e.stopPropagation();
//                                                         if (!isSelected) toggleTag(option);
//                                                     }}
//                                                     className={`h-7 w-7 rounded border flex items-center justify-center
//                                 ${isSelected
//                                                             ? "border-gray-300 text-gray-300 !cursor-default"
//                                                             : "border-green-500 bg-green-100 text-green-600 hover:bg-green-200"
//                                                         }`}
//                                                 >
//                                                     <Plus className="!text-[11px]" />{""}
//                                                 </button>

//                                                 {/* MINUS = UNSELECT */}
//                                                 <button
//                                                     type="button"
//                                                     onClick={(e) => {
//                                                         e.stopPropagation();
//                                                         if (isSelected) toggleTag(option);
//                                                     }}
//                                                     className={`h-7 w-7 rounded border flex items-center justify-center
//                                 ${isSelected
//                                                             ? "border-red-500 bg-red-100 text-red-600 hover:bg-red-200"
//                                                             : "border-gray-300 text-gray-300 !cursor-default"
//                                                         }`}
//                                                 >
//                                                     <Minus className="!text-[11px]" />{""}
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     );
//                                 })
//                             ) : (
//                                 <div className="px-3 py-2 text-sm text-gray-500">
//                                     No tags found
//                                 </div>
//                             )}
//                         </div>

//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default TagSelector;


import React, { useState, useRef, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import { IoSearchOutline } from "react-icons/io5";
import { FaPlus, FaMinus } from "react-icons/fa6";

export interface OptionType {
    value: string;
    label: string;
}

export interface IncludeExcludeValue {
    include: OptionType[];
    exclude: OptionType[];
}

interface TagSelectorProps {
    options: OptionType[];
    value: IncludeExcludeValue;
    onChange: (value: IncludeExcludeValue) => void;
    placeholder?: string;
    name?: string;

}

const TagSelector: React.FC<TagSelectorProps> = ({
    options,
    value,
    onChange,
    placeholder = "Select tag(s)",
    name,
}) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const dropdownRef = useRef<HTMLDivElement>(null);

    const Search = IoSearchOutline as any;
    const Times = FaTimes as any;
    const Plus = FaPlus as any;
    const Minus = FaMinus as any;

    /* ---------------- CLOSE ON OUTSIDE CLICK ---------------- */
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node)
            ) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    /* ---------------- CORE LOGIC ---------------- */
    const includeTag = (option: OptionType) => {
        onChange({
            include: [...value.include.filter(v => v.value !== option.value), option],
            exclude: value.exclude.filter(v => v.value !== option.value),
        });
    };

    const excludeTag = (option: OptionType) => {
        onChange({
            include: value.include.filter(v => v.value !== option.value),
            exclude: [...value.exclude.filter(v => v.value !== option.value), option],
        });
    };

    const removeTag = (option: OptionType) => {
        onChange({
            include: value.include.filter(v => v.value !== option.value),
            exclude: value.exclude.filter(v => v.value !== option.value),
        });
    };

    const filteredOptions = options.filter(opt =>
        opt.label.toLowerCase().includes(search.toLowerCase())
    );

    const allSelected = [...value.include, ...value.exclude];

    return (
        <div className="relative" ref={dropdownRef}>
            {/* ---------------- INPUT ---------------- */}
            <div
                onClick={() => setOpen(!open)}
                className="form-control assignee-div"
            >
                {allSelected.length > 0 ? (
                    <div className="flex flex-wrap gap-1">
                        {allSelected.map(tag => {
                            const isInclude = value.include.some(v => v.value === tag.value);
                            return (
                                <span
                                    key={tag.value}
                                    className={`inline-flex items-center gap-1 border text-xs px-2 py-1 rounded capitalize
                                        ${isInclude
                                            ? "bg-green-100 text-green-700 border-green-300"
                                            : "bg-red-100 text-red-700 border-red-300"
                                        }`}
                                >
                                    {tag.label}
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            removeTag(tag);
                                        }}
                                    >
                                        <Times size={11} />{""}
                                    </button>
                                </span>
                            );
                        })}
                    </div>
                ) : (
                    // <p className="m-0 text-[13px] text-gray-500"></p>
                    <span className="text-gray-500">
                        {placeholder}
                    </span>
                )}

                {/* Arrow */}
                <div className="absolute right-3">
                    <svg
                        height="20"
                        width="20"
                        viewBox="0 0 20 20"
                        className={`transition-transform ${open ? "rotate-180" : ""}`}
                    >
                        <path
                            d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615l-4.695 4.502a1.1 1.1 0 0 1-1.576 0L4.516 9.163c-0.436-0.418-0.436-1.17 0-1.615z"
                            fill="#9a9da1"
                        />
                    </svg>
                </div>
            </div>

            {/* ---------------- DROPDOWN ---------------- */}
            {open && (
                <div className="absolute z-50 mt-1 w-full rounded-lg border bg-white">
                    {/* Search */}
                    {/* <div className="flex items-center gap-2 px-3 py-2 border-b text-xs">
                        <Search className="text-gray-500" />
                        <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search tags..."
                            className="text-xs"
                            style={{
                                border: "none",
                                background: "transparent",
                                outline: "none",
                                boxShadow: "none",
                            }}
                        />
                    </div> */}
                    <div className="flex mb-2 w-full border-b border-gray-300 px-3 text-xs"
                        style={{ alignItems: "center", justifyContent: "center" }}
                    >
                        <Search className="text-base text-gray-500" />
                        <input
                            type="text"
                            placeholder="Search tags..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="text-xs"
                            style={{
                                border: "none",
                                background: "transparent",
                                outline: "none",
                                boxShadow: "none",
                            }}
                        />
                    </div>

                    {/* Header */}
                    <div className="flex justify-between px-3 py-2 text-xs text-gray-500">
                        <span>{name}</span>
                        <div className="flex gap-4">
                            <span className="flex items-center gap-1">
                                <Plus className="text-green-500 text-[11px]" />
                                Include
                            </span>
                            <span className="flex items-center gap-1">
                                <Minus className="text-red-500 text-[11px]" />
                                Exclude
                            </span>
                        </div>
                    </div>

                    {/* Options */}
                    <div className="max-h-44 overflow-auto ">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map(option => {
                                const isIncluded = value.include.some(v => v.value === option.value);
                                const isExcluded = value.exclude.some(v => v.value === option.value);

                                return (
                                    <div
                                        key={option.value}
                                        className="flex items-center justify-between px-3 py-2 hover:bg-gray-50"
                                    >
                                        <span className="text-sm capitalize">
                                            {option.label}
                                        </span>

                                        <div className="flex gap-2">
                                            {/* INCLUDE */}
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (isIncluded) {
                                                        removeTag(option);
                                                    } else {
                                                        includeTag(option);
                                                    }
                                                }}
                                                className={`h-7 w-7 flex items-center justify-center rounded border
                                                    ${isIncluded
                                                        ? "border-green-500 bg-green-100 text-green-600"
                                                        : "border-gray-400 text-gray-400"
                                                    }`}
                                            >
                                                <Plus className="text-[11px]" />{""}
                                            </button>

                                            {/* EXCLUDE */}
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (isExcluded) {
                                                        removeTag(option);
                                                    } else {
                                                        excludeTag(option);
                                                    }
                                                }}
                                                className={`h-7 w-7 flex items-center justify-center rounded border
                                                    ${isExcluded
                                                        ? "border-red-500 bg-red-100 text-red-600"
                                                        : "border-gray-400 text-gray-400"
                                                    }`}
                                            >
                                                <Minus className="text-[11px]" />{""}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="px-3 py-2 text-sm text-gray-500">
                                No tags found
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default TagSelector;
